import BadgesModel from '@/models/childcare-provider/badges';

export default {
    clear(state: any) {
        //enrollmentFormsContainer
        state.enrollmentFormsContainer.childcareEnrollmentStep = -1;
        state.enrollmentFormsContainer.currentChildcareEnrollmentStep = -1;
        state.enrollmentFormsContainer.household = null;
        state.enrollmentFormsContainer.programStatement = null;
        state.enrollmentFormsContainer.familyAmenities = null;
        state.enrollmentFormsContainer.homeSafety = null;
        state.enrollmentFormsContainer.location = null;
        state.enrollmentFormsContainer.parentBookWithApprovalRequest = false;
        state.enrollmentFormsContainer.availabilitySettings = null;
        state.enrollmentFormsContainer.acceptedAgeGroups = null;
        state.enrollmentFormsContainer.hoursOfBusiness = [];
        state.enrollmentFormsContainer.prices = null;
        state.enrollmentFormsContainer.cancellationOptions = null;
        state.enrollmentFormsContainer.policies = [];
        state.enrollmentFormsContainer.notifications = null;
        state.enrollmentFormsContainer.providerPolicies = [];
        state.enrollmentFormsContainer.badges = new BadgesModel();
        
        //orders
        state.orders.pastOrders = [];
        state.orders.currentOrders = [];
        state.orders.upcomingOrders = [];

        state.refreshChildrenList = 0;
        state.updateFamilyMembers = 0;
        state.providerForCurrentUser = null;
        state.acceptBooking = false;
        state.rejectBooking = false;
      },
      setCurrentChildcareEnrollmentStep(state: any, step: number) {
        state.enrollmentFormsContainer.currentChildcareEnrollmentStep = step;
      },
      setChildcareEnrollmentStep(state: any, steps: number) {
        if (state.enrollmentFormsContainer.childcareEnrollmentStep == -1) {
          state.enrollmentFormsContainer.currentChildcareEnrollmentStep = steps;
        }
        
        state.enrollmentFormsContainer.childcareEnrollmentStep = steps;
      },
      updateHousehold(state: any, household: any) {
        state.enrollmentFormsContainer.household = household;
      },
      updateProgramStatement(state: any, programStatement: any) {
        state.enrollmentFormsContainer.programStatement = programStatement;
      },
      updateBadges(state: any, data: any) {
        let badges = data.badges;
        let isOnlyBadges = data.isOnlyBadges;
        let badgesNames = data.badgesNames;

        if (isOnlyBadges) {
          if (badgesNames) {
            let badgesNamesArray = badgesNames.split(',');

            badgesNamesArray.forEach((badgesName: string) => {
              state.enrollmentFormsContainer.badges[badgesName] = badges[badgesName];
            });
          }
        }
        else {
          state.enrollmentFormsContainer.badges = badges;
        }
      },
      updateFamilyAmenities(state: any, familyAmenities: any) {
        state.enrollmentFormsContainer.familyAmenities = familyAmenities;
      },
      updateHomeSafety(state: any, homeSafety: any) {
        state.enrollmentFormsContainer.homeSafety = homeSafety;
      },
      updateChildcareLocation(state: any, location: any) {
        state.enrollmentFormsContainer.location = location;
      },
      updateParentBookingMethod(state: any, parentBookWithApprovalRequest: boolean) {
        state.enrollmentFormsContainer.parentBookWithApprovalRequest = parentBookWithApprovalRequest;
      },
      updateAvailabilitySettings(state: any, availabilitySettings: any) {
        state.enrollmentFormsContainer.availabilitySettings = availabilitySettings;
      },
      updateAcceptedAgeGroups(state: any, acceptedAgeGroups: any) {
        state.enrollmentFormsContainer.acceptedAgeGroups = acceptedAgeGroups;
      },
      updateHoursOfBusiness(state: any, hoursOfBusiness: any) {
        state.enrollmentFormsContainer.hoursOfBusiness = hoursOfBusiness;
      },
      updatePrices(state: any, priceList: any) {
        state.enrollmentFormsContainer.prices = priceList;
      },
      updateCancellationOptions(state: any, cancellationOptions: any) {
        state.enrollmentFormsContainer.cancellationOptions = cancellationOptions;
      },
      updatePolicies(state: any, policies: []) {
        if (!state.enrollmentFormsContainer.policies.length) {
          state.enrollmentFormsContainer.policies = [...policies];
        } else {
          for (let item of policies) {
            const policy = state.enrollmentFormsContainer.policies.find((p: any) => p.id === (item as any).policyId);
            if (policy && typeof (item as any).checked !== 'undefined') {
              const index = state.enrollmentFormsContainer.policies.indexOf(policy);
              state.enrollmentFormsContainer.policies.splice(index, 1, {
                checked: !!(item as any).checked,
                id: (item as any).policyId,
                name: policy.name,
                text: (item as any).text
              })
            }
          }
        }
      },
      updateProviderPolicies(state: any, providerPolicies: []) {
        state.providerPolicies = providerPolicies;
      },
      updateNotifications(state: any, notifications: any) {
        state.enrollmentFormsContainer.notifications = notifications;
      },
      refreshChildrenList(state: any) {
        state.refreshChildrenList++;
      },
      updateFamilyMembers(state: any) {
        state.updateFamilyMembers++;
      },
      setProviderForCurrentUser(state: any, provider: any) {
        state.providerForCurrentUser = provider;
      },
      setAcceptBooking(state: any, acceptBooking: boolean) {
        state.acceptBooking = acceptBooking;
      },
      setRejectBooking(state: any, rejectBooking: boolean) {
        state.rejectBooking = rejectBooking;
      }
}